import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';

@Component({
    templateUrl: './salario-minimo.component.html',
    selector: 'salario-minimo-list'
})
export class SalarioMinimoComponent {
    public codigo: any;
    // construtor
    constructor(private router: Router,
    private mensagem: MatSnackBar) {   }

    erro(erro: string){
      this.mensagem.open(erro, 'X', {duration: 5000});
    }

}
